module.exports = __webpack_public_path__ + "static/media/phoneIcon.5c4b9b9c.svg";